import { render, staticRenderFns } from "./forGms.vue?vue&type=template&id=5b22e6ec&scoped=true&"
import script from "./forGms.vue?vue&type=script&lang=js&"
export * from "./forGms.vue?vue&type=script&lang=js&"
import style0 from "./forGms.vue?vue&type=style&index=0&id=5b22e6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22e6ec",
  null
  
)

export default component.exports